export const MAX_LENGTH_INPUT = 60

export const MIN_LENGTH_INPUT = 1

export const TIME_DEBOUNCE = 700
